import React from "react";
import CajaVacia from "./CajaVacia";
import '../App.css';

export default function Reservas() {
    return (
        <div className="contenedor-principal">
            <section className="contenido reservas">
                {/*<h2>Reservá tu expedición MTB</h2>
                <p>Completá tus datos y te respondemos con disponibilidad, recomendaciones y precio final.</p>
*/}
                <section id={"aventura-en-seismiles"}>
                    <CajaVacia
                        encabezado={"Quiero reservar mi expedición"}
                        titulo={"Tu lugar en la próxima aventura"}
                        descripcion={
                            "Cupos limitados: máximo 3 ciclistas por salida. Traslado puerta a puerta incluido."
                        }
                        boton={""}
                    />
                    {/*<div className="contenedor-imagenes"></div>*/}
                </section>

                <form className="form-reservas">
                    <input type="text" placeholder="Nombre y apellido" />
                    <input type="tel" placeholder="WhatsApp" />
                    <input type="email" placeholder="Email" />
                    <input type="date" />
                    <input type="number" placeholder="Cantidad de personas" min="1" />
                    <select>
                        <option>Nivel MTB</option>
                        <option>Principiante</option>
                        <option>Intermedio</option>
                        <option>Avanzado</option>
                    </select>
                    <textarea placeholder="Contanos qué tipo de salida querés hacer"></textarea>
                    <button className={"boton-enfasis"} type="submit">Reservar</button>
                </form>
            </section>
        </div>
    );
}